"use client";

export { default } from "./landing/page";
